import React, {useRef, useState} from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import SignUpDialog from "../shared/SignUpDialog";
import timecrunchScreenshot from "../assets/timecrunch-screenshot-2.png";
import {motion} from "framer-motion";
import useMediaQuery from "../hooks/useMediaQuery";

const LandingV2 = ({setSelectedPage}) => {
    const isAboveMd = useMediaQuery("(min-width: 768px)")
    const isMobile = useMediaQuery("(max-width: 768px)");
    const isLandscapeMobile = useMediaQuery(
        "(max-height: 440px) and (orientation: landscape)"
    )
    const [signingUp, setSigningUp] = useState(false);

    const videoRef1 = useRef(null);
    const videoRef2 = useRef(null);

    const handleMouseEnter = (ref) => {
        ref.current?.play();
    };

    const handleMouseLeave = (ref) => {
        ref.current?.pause();
        ref.current.currentTime = 0; // Optional: reset to start
    };

    return (

        <section id="home">
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    alignItems: "center",
                    textAlign: "center",
                    height: "100vh",
                    gap: isAboveMd ? '1rem' : '0.75rem',
                    fontFamily: "Montserrat, sans-serif",
                }}
            >
                {/* Heading */}
                <h1 className="text-5xl md:text-7xl text-black font-bold">TIMECRUNCH</h1>
                <p className="font-semibold">
                    The <span className="text-gray-400">essential</span> Add-On for{" "}
                    <a
                        href="https://www.tennistv.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                    >
                        ATP Tennis TV{" "}
                    </a>
                    and{" "}
                    <a
                        href="https://www.tennischannel.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                    >
                        Tennis Channel Plus
                    </a>{" "}
                    subscribers
                </p>

                <p>TimeCrunch removes non playing time from tennis matches</p>
                <p>Skipping change-overs and time between points.</p>
                <p>Save time and enhance your viewing experience!</p>

                {/* Sign Up Button */}
                <motion.div
                    className="flex justify-center gap-4 w-full px-4"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true, amount: 0.5}}
                    transition={{delay: 0.5, duration: 0.5}}
                    variants={{
                        hidden: {opacity: 0, y: 100},
                        visible: {opacity: 1, y: 0},
                    }}
                >
                    <button
                        onClick={() => setSigningUp(true)}
                        className="z-10 bg-gradient-to-r from-green-400 to-teal-400 p-[1px] rounded-lg font-semibold text-gray-100 active:translate-y-[1px] active:translate-x-[1px] w-full max-w-xs md:max-w-md"
                    >
                        <div
                            className="bg-neutral-700 rounded-lg py-3 px-6 hover:text-neutral-950 hover:bg-transparent">
                            Sign Up Now
                        </div>
                    </button>
                </motion.div>

                {/* Video Container */}
                <motion.div
                    className="group flex relative p-4 rounded-[2.5rem] w-full sm:w-11/12 md:w-4/5"
                    style={{
                        background: "linear-gradient(to right, rgb(127,245,57), rgb(45,212,191))",
                        boxShadow: "inset 0 0 12px 12px white, inset 0 0 3px 2px white",
                    }}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true, amount: 0.5}}
                    transition={{delay: 0.7, duration: 0.5}}
                    variants={{
                        hidden: {opacity: 0},
                        visible: {opacity: 1},
                    }}
                >
                    {/*<video className="rounded-[2.5rem] w-full h-auto" controls autoPlay muted playsInline>*/}
                    {/*    <source src={process.env.REACT_APP_DEMO_VIDEO_KEY} type="video/mp4"/>*/}
                    {/*    Your browser does not support the video tag*/}
                    {/*</video>*/}
                    <video
                        style={{
                            borderTopLeftRadius: '2.5rem',
                            borderBottomLeftRadius: '2.5rem'
                        }}
                        ref={videoRef1}
                        src={process.env.REACT_APP_DEMO_TCPLUS_VIDEO_KEY}
                        width="50%"
                        onMouseEnter={() => handleMouseEnter(videoRef1)}
                        onMouseLeave={() => handleMouseLeave(videoRef1)}
                        muted
                    />
                    <video
                        style={{
                            borderTopRightRadius: '2.5rem',
                            borderBottomRightRadius: '2.5rem'
                        }}
                        ref={videoRef2}
                        src={process.env.REACT_APP_DEMO_TTV_VIDEO_KEY}
                        width="50%"
                        onMouseEnter={() => handleMouseEnter(videoRef2)}
                        onMouseLeave={() => handleMouseLeave(videoRef2)}
                        muted
                    />

                    {/*<motion.div*/}
                    {/*    initial="hidden"*/}
                    {/*    whileInView="visible"*/}
                    {/*    viewport={{once: true, amount: 0.5}}*/}
                    {/*    transition={{delay: 1.5, duration: 1.0}}*/}
                    {/*    variants={{*/}
                    {/*        hidden: {opacity: 0},*/}
                    {/*        visible: {opacity: 1},*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <img*/}
                    {/*        src={timecrunchScreenshot}*/}
                    {/*        alt="Top-right icon"*/}
                    {/*        className="absolute w-1/4 h-1/4 md:w-1/5 md:h-1/5 rounded shadow-lg transition-opacity duration-300 group-hover:opacity-10 z-10"*/}
                    {/*        style={{*/}
                    {/*            top: isAboveMd? "-1.5rem" : "-0.5rem",*/}
                    {/*            right: isAboveMd ? "-1.5rem"  : "1.0rem",*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</motion.div>*/}
                </motion.div>

                {/* Bottom Links */}
                <motion.div
                    className="flex flex-wrap justify-center gap-4 w-full px-4"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true, amount: 0.5}}
                    transition={{delay: 1.5, duration: 1.0}}
                    variants={{
                        hidden: {opacity: 0, y: 100},
                        visible: {opacity: 1, y: 0},
                    }}
                >
                    <a
                        href={process.env.REACT_APP_CHROME_EXTENSION_LISTING_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="shadow z-10 w-40 border border-gray-800 p-3 rounded-lg font-semibold text-gray-800 hover:bg-gradient-brand-gray hover:text-neutral-950 active:translate-y-[1px] active:translate-x-[1px]"
                    >
                        Download
                    </a>
                    <a
                        href={process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="shadow z-10 w-40 border border-gray-800 p-3 rounded-lg font-semibold text-gray-800 hover:bg-gradient-brand-gray hover:text-neutral-950 active:translate-y-[1px] active:translate-x-[1px]"
                    >
                        My Account
                    </a>
                    {isAboveMd && (
                        <AnchorLink
                        onClick={() => setSelectedPage("contact")}
                        href="#contact"
                        className="shadow z-10 w-40 border border-gray-800 p-3 rounded-lg font-semibold text-gray-800 hover:bg-gradient-brand-gray hover:text-neutral-950 active:translate-y-[1px] active:translate-x-[1px]"
                    >
                        Contact Us
                    </AnchorLink>)}
                </motion.div>
            </div>
            <SignUpDialog isOpen={signingUp} setIsOpen={setSigningUp}/>
        </section>


    )
        ;
};

export default LandingV2;
